import axios from "axios";

import { endpoints } from "../../../api/endpoints";
import { MatchScoringInput, ScoredMatch } from "./matchScoring";
import { IntakeAnswer, MatchProfile } from "../types/interviewSession";

const SESSION_ID_KEY = "werule-intake-session-id";

export function getOrCreateSessionId(): string {
  const existing = sessionStorage.getItem(SESSION_ID_KEY);
  if (existing) return existing;
  const id = crypto.randomUUID();
  sessionStorage.setItem(SESSION_ID_KEY, id);
  return id;
}

export function getStoredSessionId(): string | null {
  return sessionStorage.getItem(SESSION_ID_KEY);
}

type PersistPayload = {
  sessionId: string;
  journeyType?: string;
  role?: string;
  answersJson?: IntakeAnswer[];
  matchProfileJson?: MatchProfile | null;
  sessionInputJson?: MatchScoringInput | null;
  scoredMatchesJson?: ScoredMatch[];
  soulMatch?: boolean;
  completed?: boolean;
};

export async function persistIntakeSession(payload: PersistPayload): Promise<string | null> {
  try {
    const response = await axios.post<{ sessionId: string }>(
      endpoints.intakeSessions,
      {
        sessionId: payload.sessionId,
        journeyType: payload.journeyType,
        role: payload.role ?? "mentee",
        answersJson: payload.answersJson ?? [],
        matchProfileJson: payload.matchProfileJson,
        sessionInputJson: payload.sessionInputJson,
        scoredMatchesJson: payload.scoredMatchesJson,
        soulMatch: payload.soulMatch ?? false,
        completed: payload.completed ?? false,
      },
      { withCredentials: false }
    );
    return response.data.sessionId ?? payload.sessionId;
  } catch (error) {
    console.error("[Intake] Failed to persist session:", error);
    return null;
  }
}

export async function fetchIntakeSession(sessionId: string) {
  try {
    const response = await axios.get(endpoints.intakeSession(sessionId), {
      withCredentials: false,
    });
    return response.data as {
      sessionId: string;
      scoredMatchesJson?: string;
      sessionInputJson?: string;
    };
  } catch {
    return null;
  }
}

export function parseScoredMatchesFromServer(raw?: string): ScoredMatch[] | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ScoredMatch[];
  } catch {
    return null;
  }
}
